<div #gripper 
    (mousedown)="dragstart($event)" 
    class="{{GripperClass}} {{BackgroundClass}}">


    <span [ngClass]="ThumbClass">
        
    </span>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/base/thumb/thumb.html